import React from 'react';

import styles from './RotateDevice.module.scss';

export default function RotateDevice() {
    return (
        <div className={styles.container}>
            <div className={styles.phone}/>
            <div className={styles.message}>
                Please rotate your device!
            </div>
        </div>
    );
}
